import "./RateParityMonitoringCorrection.module.css";
import Header from "@/reusable_sections/Header";
import RevenueHero from "./sections/RevenueHero";
import RevenueJourneyContactForm from "./sections/RevenueJourneyContactForm";
import RevenueWorkflow from "./sections/RevenueWorkflow";
import RevenueFaq from "./sections/RevenueFaq";
import RevenueAudit from "./sections/RevenueAudit";
import Footer from "@/reusable_sections/Footer";
export default function RateParityMonitoringCorrectionPage() {
  return <div>
      <Header />
      <RevenueHero />
      <RevenueJourneyContactForm />
      <RevenueWorkflow />
      <RevenueFaq />
      <RevenueAudit />
      <Footer />
    </div>;
}